const reviewsCarousel = {
    openDialog(dialog) {
        if (!dialog || dialog.open) return
        if (dialog.showModal) {
            dialog.showModal()
            return
        }
        dialog.setAttribute('open', '')
    },

    closeDialog(dialog) {
        if (!dialog) return
        if (dialog.close) {
            dialog.close()
            return
        }
        dialog.removeAttribute('open')
    },

    updateOverflow(root) {
        root.querySelectorAll('.reviews-carousel-card').forEach(card => {
            const excerpt = card.querySelector('.reviews-carousel-excerpt')
            const openButton = card.querySelector('[data-review-dialog-open]')
            if (!excerpt || !openButton) return

            const hasOverflow = excerpt.scrollHeight > excerpt.clientHeight + 1
            openButton.hidden = !hasOverflow
        })
    },

    init(container = document) {
        const roots = container.querySelectorAll('[data-reviews-carousel]')
        if (roots.length === 0) return

        roots.forEach(root => {
            if (root.dataset.reviewsCarouselInit === 'true') return
            root.dataset.reviewsCarouselInit = 'true'

            this.updateOverflow(root)
            window.addEventListener('load', () => this.updateOverflow(root), { once: true })
            window.addEventListener('resize', () => this.updateOverflow(root))

            root.addEventListener('click', event => {
                const openButton = event.target.closest('[data-review-dialog-open]')
                if (openButton) {
                    const dialog = root.querySelector(`#${openButton.getAttribute('aria-controls')}`)
                    this.openDialog(dialog)
                    return
                }

                const closeButton = event.target.closest('[data-review-dialog-close]')
                if (closeButton) {
                    this.closeDialog(closeButton.closest('dialog'))
                }
            }, { capture: true })

            root.querySelectorAll('dialog[data-review-dialog]').forEach(dialog => {
                dialog.addEventListener('click', event => {
                    if (event.target === dialog) this.closeDialog(dialog)
                })
            })
        })
    },
}

export default reviewsCarousel
